const data = [
  {
    order: '944046770',
    name: 'Jane Cooper',
    guests: 1,
    // unread: true
  },
  {
    order: '944046770',
    name: 'Wade Warren',
    guests: 2,
    // unread: true
  },
  {
    order: '944046770',
    name: 'Easter Howard',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Cameron Williamson',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Brooklyn Simmons',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Leslie Alexander',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Jenny Wilson',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Guy Hawkins',
    guests: 1,
  },
  {
    order: '944046770',
    name: 'Robert Fox',
    guests: 2,
  },
  {
    order: '944046770',
    name: 'Jacob Jones',
    guests: 1,
  },
]

export default data